import type { OAuthCallbackParams, OAuthHandler } from '../oauth-callback.types';

class OAuthHandlerRegistryClass {
	private readonly _handlers: Map<string, OAuthHandler> = new Map();

	public register(handler: OAuthHandler): void {
		this._handlers.set(handler.name, handler);
	}

	public findHandler(params: OAuthCallbackParams): OAuthHandler | null {
		for (const handler of this._handlers.values()) {
			if (handler.canHandle(params)) {
				return handler;
			}
		}

		return null;
	}

	public getHandler(name: string): OAuthHandler | null {
		return this._handlers.get(name) ?? null;
	}
}

export const OAuthHandlerRegistry = new OAuthHandlerRegistryClass();
